var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-wrapper", attrs: { id: "formWrapper" } },
    [
      _c(
        "fieldset",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.order_status != "success",
              expression: "order_status != 'success'",
            },
          ],
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Voor specifieke wensen, combinatie uitjes, groepsprijzen en speciale programma’s kun je vrijblijvend een offerte aanvragen. Je krijgt zo spoedig mogelijk antwoord!"
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "borderradius" },
            [
              _c("div", { staticClass: "field-wrapper bg" }, [
                _c("label", [_vm._v("Activiteit")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activity,
                        expression: "activity",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.activity = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v("Selecteer een activiteit"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.activities, function (item, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: index } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.activity
                  ? _c("div", { staticClass: "field-wrapper bg" }, [
                      _c("label", [_vm._v("Arrangement")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.arrangement_id,
                              expression: "arrangement_id",
                            },
                          ],
                          on: {
                            blur: function ($event) {
                              return _vm.$v.arrangement_id.$touch()
                            },
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.arrangement_id = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Selecteer een arrangement"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.arrangements, function (item, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: index } },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.arrangement
                  ? _c(
                      "div",
                      {
                        staticClass: "product-overview",
                        class: _vm.activity_color,
                      },
                      [
                        _c("div", { staticClass: "input left-column" }, [
                          _c("div", { staticClass: "field-wrapper bg" }, [
                            _c("label", [_vm._v("Aantal personen")]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.lazy",
                                  value: _vm.no_persons,
                                  expression: "no_persons",
                                  modifiers: { lazy: true },
                                },
                              ],
                              attrs: {
                                disabled: _vm.lock_persons,
                                type: "number",
                                pattern: "\\d*",
                              },
                              domProps: { value: _vm.no_persons },
                              on: {
                                blur: function ($event) {
                                  return _vm.$v.no_persons.$touch()
                                },
                                change: function ($event) {
                                  _vm.no_persons = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field-wrapper bg" },
                            [
                              _c("label", [_vm._v("Datum & Tijdstip")]),
                              _vm._v(" "),
                              _c("flat-pickr", {
                                attrs: {
                                  config: _vm.flatpickr.config_datepicker,
                                  placeholder: "Selecteer je datum",
                                  name: "reservation_date",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$v.reservation_date.$touch()
                                  },
                                },
                                model: {
                                  value: _vm.reservation_date,
                                  callback: function ($$v) {
                                    _vm.reservation_date = $$v
                                  },
                                  expression: "reservation_date",
                                },
                              }),
                              _vm._v(" "),
                              _c("flat-pickr", {
                                attrs: {
                                  config: _vm.flatpickr.config_timepicker,
                                  placeholder: "Selecteer je tijdstip",
                                  name: "reservation_time",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.$v.reservation_time.$touch()
                                  },
                                },
                                model: {
                                  value: _vm.reservation_time,
                                  callback: function ($$v) {
                                    _vm.reservation_time = $$v
                                  },
                                  expression: "reservation_time",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right-column" }, [
                          _c(
                            "article",
                            {
                              staticClass: "cpa large",
                              class: _vm.activity_color,
                            },
                            [
                              _vm.arrangement.thumbnail
                                ? _c("div", { staticClass: "image-wrapper" }, [
                                    _c("a", { attrs: { href: "#" } }, [
                                      _c("picture", [
                                        _c("source", {
                                          attrs: {
                                            media: "(min-width: 640px)",
                                            srcset:
                                              _vm.arrangement.thumbnail.large,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("source", {
                                          attrs: {
                                            media: "(max-width: 640px)",
                                            srcset:
                                              _vm.arrangement.thumbnail.medium,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                          attrs: {
                                            src: _vm.arrangement.thumbnail
                                              .medium,
                                            alt: _vm.arrangement.thumbnail.alt,
                                          },
                                        }),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "cpa__content" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge",
                                    class: _vm.activity_color,
                                  },
                                  [_vm._v(_vm._s(_vm.arrangement.ages[0].name))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "cpa__meta" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "cpa__title",
                                      attrs: { href: "#" },
                                    },
                                    [
                                      _c("h3", [
                                        _vm._v(_vm._s(_vm.arrangement.name)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "cpa__price" }, [
                                    _c("span", { staticClass: "number" }, [
                                      _vm._v(_vm._s(_vm.arrangement.price)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "suffix" }, [
                                      _vm._v("p.p."),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "cpa__subtitle" }, [
                                    _vm._v(_vm._s(_vm.arrangement.extra_info)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "no-bullet" },
                                  _vm._l(
                                    _vm.arrangement.features,
                                    function (item, index) {
                                      return _c("li", { key: index }, [
                                        _c("div", { staticClass: "icon" }, [
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "check",
                                              attrs: {
                                                width: "100%",
                                                height: "100%",
                                              },
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    "/wp-content/themes/battlehouse/dist/images/spritemap.svg#sprite-check",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "text" }, [
                                          _c("span", [
                                            _vm._v(_vm._s(item.feature)),
                                          ]),
                                        ]),
                                      ])
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "fieldset",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.order_status != "success",
              expression: "order_status != 'success'",
            },
          ],
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "borderradius" }, [
            _c("div", { staticClass: "field-wrapper bg" }, [
              _c("label", [_vm._v("Naam")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.client_name,
                    expression: "client_name",
                    modifiers: { lazy: true },
                  },
                ],
                class: {
                  is_invalid:
                    _vm.$v.client_name.$error && _vm.$v.client_name.$dirty,
                  is_valid:
                    !_vm.$v.client_name.$error && _vm.$v.client_name.$dirty,
                },
                attrs: { type: "text", name: "client_name" },
                domProps: { value: _vm.client_name },
                on: {
                  blur: function ($event) {
                    return _vm.$v.client_name.$touch()
                  },
                  change: function ($event) {
                    _vm.client_name = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-wrapper bg" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.client_phone,
                    expression: "client_phone",
                    modifiers: { lazy: true },
                  },
                ],
                class: {
                  is_invalid:
                    _vm.$v.client_phone.$error && _vm.$v.client_phone.$dirty,
                  is_valid:
                    !_vm.$v.client_phone.$error && _vm.$v.client_phone.$dirty,
                },
                attrs: { type: "tel", name: "client_phone" },
                domProps: { value: _vm.client_phone },
                on: {
                  blur: function ($event) {
                    return _vm.$v.client_phone.$touch()
                  },
                  change: function ($event) {
                    _vm.client_phone = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Om contact op te nemen over je boeking.")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-wrapper bg" }, [
              _c("label", [_vm._v("E-mailadres")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.client_email,
                    expression: "client_email",
                    modifiers: { lazy: true },
                  },
                ],
                class: {
                  is_invalid:
                    _vm.$v.client_email.$error && _vm.$v.client_email.$dirty,
                  is_valid:
                    !_vm.$v.client_email.$error && _vm.$v.client_email.$dirty,
                },
                attrs: { type: "text", name: "client_email" },
                domProps: { value: _vm.client_email },
                on: {
                  blur: function ($event) {
                    return _vm.$v.client_email.$touch()
                  },
                  change: function ($event) {
                    _vm.client_email = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-wrapper bg" }, [
              _c("label", [_vm._v("Vragen / wensen")]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.lazy",
                    value: _vm.order_comments,
                    expression: "order_comments",
                    modifiers: { lazy: true },
                  },
                ],
                attrs: { rows: "8" },
                domProps: { value: _vm.order_comments },
                on: {
                  change: function ($event) {
                    _vm.order_comments = $event.target.value
                  },
                },
              }),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("legend", [_c("h2", [_vm._v("Online reserveren")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("legend", [_c("h2", [_vm._v("Persoonsgegevens")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field-optional" }, [
      _c("label", [_vm._v("Telefoonnummer")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/orderForm.vue